<template>
  <b-row class="project-detail">
		<b-col>
			<b-nav tabs>
				<b-nav-item
					v-for="link in linksToShow"
					:key="link.name"
					:to="link.url"
					exact 
					exact-active-class="active"
          link-classes="project-nav__link"
				>
					<b-icon :icon="link.icon" class="project-nav__icon" />
					{{ link.name }}
				</b-nav-item>
        <b-nav-item-dropdown
          id="my-nav-dropdown"
          toggle-class="project-nav__link"
          link-classes="project-nav__link"
          right
        >
          <template #button-content>
            <b-icon icon='gear-fill'></b-icon> Project Settings
          </template>
          <b-dropdown-item 
            class="body-p"
            :to="`/project/${projectId}/edit`"
          >
            <b-icon icon='pencil-square'></b-icon> Edit Project
          </b-dropdown-item>
          <b-dropdown-item 
            class="body-p"
            :to="`/project/${projectId}/close`"
          >
            <b-icon icon='door-closed-fill'></b-icon> Close Project
          </b-dropdown-item>
        </b-nav-item-dropdown>
			</b-nav>
		</b-col>
	</b-row>
</template>

<script>
// import axios from "axios";
// import ComponentName from "@/components/ComponentName.vue";

export default {
  components: {
    // ComponentName
  },
  props: {
    isKickoffCompleted: { type: Boolean, default: false }
  },
  data() {
    return {
    }
  },
  computed: {
		projectId() {
			return this.$route.params.id;
		},
		links() {
			return [
				{
					name: 'Overview',
					icon: 'bar-chart-fill',
					url: `/project/${this.projectId}`,
          requiresKickoff: false
				},
				{
					name: 'Users',
					icon: 'people-fill',
					url: `/project/${this.projectId}/users`,
          requiresKickoff: false
				},
				{
					name: 'Facilitator',
					icon: 'person-circle',
					url: `/project/${this.projectId}/facilitator`,
          requiresKickoff: false
				},
				{
					name: 'Charter',
					icon: 'award',
					url: `/project/${this.projectId}/charter`,
          requiresKickoff: true
				},
				{
					name: 'Evaluation',
					icon: 'clipboard-check',
					url: `/project/${this.projectId}/evaluation`,
          requiresKickoff: true
				},
				{
					name: 'Action Items',
					icon: 'plus-circle-fill',
					url: `/project/${this.projectId}/action-items`,
          requiresKickoff: false
				},
			]
		},
    linksToShow() {
      return this.isKickoffCompleted ?
        this.links :
        this.links.filter(link => !link.requiresKickoff);
    },
  },
  watch: {

  },
  mounted() {
    // this.loadData();
  },
  methods: {
    // loadData() {
    //   const url = `${this.$api_url}/v1/...`;

    //   axios
    //     .get(
    //       url,
    //       this.$auth.getReqConfig(this.$store.getters["auth/getToken"])
    //     )
    //     .then((res) => {

    //     })
    //     .catch((err) => {
    //       this.$error({
    //         msg: "Couldn't load data",
    //         obj: err,
    //       });
    //     })
    //     .finally(() => {

    //     });
    // },
  }
}
</script>

<style lang="scss" scoped>

</style>
